import {
	Component,
	ElementRef,
	EventEmitter,
	Input,
	OnInit,
	Output,
	ViewChild,
} from '@angular/core';
import { ENTER } from '@angular/cdk/keycodes';
import { UntypedFormControl } from '@angular/forms';
import { MatLegacyAutocomplete as MatAutocomplete, MatLegacyAutocompleteSelectedEvent as MatAutocompleteSelectedEvent } from '@angular/material/legacy-autocomplete';

import { CarrierDTOResponse, RestService } from 'cargo-chief-commons';

import { UrlService } from '@service/url/url.service';
import { SNACKBAR } from '@domain/constants/snackbar-setting';
import { UtilService } from '@service/util/util.service';
import { Cargochief } from '@service/cargochief/cargochief.service';

@Component({
	selector: 'app-carrier-selector',
	templateUrl: './carrier-selector.component.html',
	styleUrls: ['./carrier-selector.component.scss'],
})
export class CarrierSelectorComponent implements OnInit {
	@Input() public projectId: string = null;
	@Input() public carrierId: string = null;
	@Input() public useSelect: boolean = false;
	@Input() public useAutoComplete: boolean = false;
	@Input() public inputPlaceholder: string = 'Select carrier';
	@Output() updatedCarrier: EventEmitter<any> = new EventEmitter();

	carrierIdsList: Array<string> = [];
	carriersList: Array<CarrierDTOResponse> = null;
	isLoadingCarrier: boolean = false;
	accountId: number = null;

	visible = true;
	selectable = true;
	removable = true;
	separatorKeysCodes: number[] = [ENTER];
	carrierListCtrl = new UntypedFormControl();
	filteredOptions = [];
	chips = [];
	selectedCarrier: CarrierDTOResponse = null;

	@ViewChild('carrierInput') carrierInput: ElementRef<HTMLInputElement>;
	@ViewChild('auto') matAutocomplete: MatAutocomplete;

	constructor(
		public utilService: UtilService,
		private urlService: UrlService,
		private restService: RestService,
		public cargochief: Cargochief
	) {
		this.carrierListCtrl.valueChanges.subscribe((val) => {
			this.filterOptions(val);
		});
	}

	ngOnInit() {
		this.accountId = this.cargochief.ACCOUNT_ID;
		if (!this.utilService.isNullOrUndefined(this.projectId)) {
			this.getCarrierIdsByProjectIds();
		}
	}

	getCarrierIdsByProjectIds() {
		this.isLoadingCarrier = true;
		const url = this.urlService.getCarrierIdsByProjectIds();
		this.restService.POST(url, { projectIds: [this.projectId] }).subscribe(
			(result) => {
				this.carrierIdsList = result.data.carrierIDs;
				if (
					!this.utilService.isNullOrUndefined(this.carrierIdsList) &&
					this.carrierIdsList.length > 0
				) {
					this.searchFilteredCarriers();
				} else {
					this.isLoadingCarrier = false;
				}
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to get carriers for selected projects.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.carriersList = [];
				this.isLoadingCarrier = false;
			}
		);
	}

	searchFilteredCarriers() {
		this.carriersList = null;
		const url = this.urlService.getCarriersByIds();
		const payload = {
			carrierIDs: this.carrierIdsList,
			accountId: this.accountId,
		};
		this.restService.POST(url, payload).subscribe(
			(result) => {
				this.carriersList = result.data['content'];
				this.filteredOptions = this.carriersList;
				this.isLoadingCarrier = false;
			},
			(error) => {
				this.utilService.showSnackbar(
					'Unable to get carriers list for the project.',
					SNACKBAR.ERROR,
					SNACKBAR.ACTION
				);
				this.carriersList = [];
				this.isLoadingCarrier = false;
			}
		);
	}

	carrierSelected(carrier: CarrierDTOResponse) {
		this.updatedCarrier.emit(carrier);
	}

	filterOptions(text: string) {
		this.filteredOptions = this.carriersList.filter(
			(carrier) => carrier.businessName.toLowerCase().indexOf(text.toString().toLowerCase()) === 0
		);
	}

	addChip(event: MatAutocompleteSelectedEvent, input: any): void {
		const selection: CarrierDTOResponse = event.option.value;
		this.chips.push(selection);
		this.carrierSelected(selection);
		if (input) {
			input.value = '';
		}
	}
}
